import { render } from "./led.vue?vue&type=template&id=04992cbc&lang=pug"
import script from "./led.vue?vue&type=script&lang=js"
export * from "./led.vue?vue&type=script&lang=js"

import "./led.vue?vue&type=style&index=0&id=04992cbc&lang=less"

import exportComponent from "/home/runner/work/argos-control-web/argos-control-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__